import { WatchedList } from "@kernel/ddd";
import { Room } from "./Room";

export class RoomList extends WatchedList<Room> {
  private constructor(initialItems: Room[]) {
    super(initialItems);
  }

  public compareItems(a: Room, b: Room): boolean {
    return a.equals(b);
  }

  public static create(initialItems?: Room[]): RoomList {
    return new RoomList(initialItems ? initialItems : []);
  }
}
